import { render, staticRenderFns } from "./ServiceLink.vue?vue&type=template&id=ddaa58ac&scoped=true"
import script from "./ServiceLink.vue?vue&type=script&lang=ts"
export * from "./ServiceLink.vue?vue&type=script&lang=ts"
import style0 from "./ServiceLink.vue?vue&type=style&index=0&id=ddaa58ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaa58ac",
  null
  
)

export default component.exports